import { useTranslation } from 'react-i18next';
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Small hook that fetches (and caches) the current user's default
 * signature. Callers use ``savedSignature`` as the ``savedSignature``
 * prop on ``<SignaturePad />`` to get a **"Use saved"** button, and
 * ``saveAsDefault`` to persist the current pad content as the user's
 * new default without leaving the sign-off screen.
 */
export function useDefaultSignature() {
  const { t } = useTranslation();
  const [savedSignature, setSavedSignature] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/auth/me/signature`);
      setSavedSignature(r.data?.signature_image || null);
    } catch (_e) { setSavedSignature(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const saveAsDefault = useCallback(async (dataUrl) => {
    try {
      await axios.put(`${API}/auth/me/signature`, { signature_image: dataUrl });
      setSavedSignature(dataUrl);
      return true;
    } catch (_e) { return false; }
  }, []);

  const clearDefault = useCallback(async () => {
    try {
      await axios.delete(`${API}/auth/me/signature`);
      setSavedSignature(null);
      return true;
    } catch (_e) { return false; }
  }, []);

  return { savedSignature, saveAsDefault, clearDefault, loading, reload };
}
